/** Shared Tools rightbar most-recently-used section order. */

export type ToolsSectionId = 'saved' | 'stats' | 'searches' | 'compare' | 'viewed';

export const TOOLS_SECTION_ORDER_KEY = 'browse_tools_section_order_v1';
export const TOOLS_LAST_USED_KEY = 'browse_tools_last_used_v1';

export const DEFAULT_TOOLS_SECTION_ORDER: ToolsSectionId[] = [
  'saved',
  'stats',
  'searches',
  'compare',
  'viewed',
];

export function getToolsSectionOrder(): ToolsSectionId[] {
  try {
    const raw = sessionStorage.getItem(TOOLS_SECTION_ORDER_KEY);
    if (!raw) {
      return [...DEFAULT_TOOLS_SECTION_ORDER];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [...DEFAULT_TOOLS_SECTION_ORDER];
    }
    const valid = parsed.filter((id: string): id is ToolsSectionId =>
      DEFAULT_TOOLS_SECTION_ORDER.includes(id as ToolsSectionId));
    const missing = DEFAULT_TOOLS_SECTION_ORDER.filter(id => !valid.includes(id));
    return [...valid, ...missing];
  } catch {
    return [...DEFAULT_TOOLS_SECTION_ORDER];
  }
}

export function getLastToolsSection(): ToolsSectionId | null {
  try {
    const raw = sessionStorage.getItem(TOOLS_LAST_USED_KEY);
    if (raw && DEFAULT_TOOLS_SECTION_ORDER.includes(raw as ToolsSectionId)) {
      return raw as ToolsSectionId;
    }
  } catch {
    // ignore
  }
  const order = getToolsSectionOrder();
  return order[0] || null;
}

/** Move a Tools section to the top and remember it as last used. */
export function promoteToolsSection(id: ToolsSectionId): ToolsSectionId[] {
  if (!DEFAULT_TOOLS_SECTION_ORDER.includes(id)) {
    return getToolsSectionOrder();
  }
  const next = [id, ...getToolsSectionOrder().filter(sectionId => sectionId !== id)];
  try {
    sessionStorage.setItem(TOOLS_SECTION_ORDER_KEY, JSON.stringify(next));
    sessionStorage.setItem(TOOLS_LAST_USED_KEY, id);
  } catch {
    // ignore
  }
  return next;
}
